import React from 'react';

interface Props {
  heading: string;
  children: React.ReactNode;
}

export function TopInstallInstructions(props: Props) {
  return (
    <div className="bg-white rounded-8 p-5 flex flex-1 flex-col gap-2 shadow-[0_4px_15px_0px_rgba(0,0,0,0.15)]">
      <h3 className="text-lg font-bold">{props.heading}</h3>
      {props.children}
    </div>
  );
}
